import type { CSSProperties } from 'react';

import classnames from 'classnames';

import { Icon } from '@/icon';

import * as styles from '../Signup.css';

interface SignupInputProps {
  icon: any;
  inputPlaceholder: string;
  handleEmailChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  inputStyle: CSSProperties;
}

const SignupInput = ({ icon, inputPlaceholder, handleEmailChange, inputStyle }: SignupInputProps) => {
  return (
    <div className="flex items-center gap-2 w-full">
      <div className="relative w-full">
        {icon && (
          <div className={classnames(styles.inputIcon, 'absolute top-1/2 -translate-y-1/2 left-4')}>
            {icon.type === 'icon' && (
              <Icon type={icon.iconType} name={icon.iconName} size={20} className={classnames(styles.inputIcon)} />
            )}
            {icon.type === 'emoji' && <span>{icon.content}</span>}
          </div>
        )}
        <input
          type="email"
          name="email"
          required={true}
          autoComplete="off"
          className={classnames(styles.input, 'w-full pr-4 cursor-text', icon ? 'pl-10' : 'pl-4')}
          style={inputStyle}
          placeholder={inputPlaceholder}
          onChange={handleEmailChange}
        />
      </div>
    </div>
  );
};

export default SignupInput;
